export default __webpack_public_path__ + "static/discover_icon-23e86ce60c5db60fa58863f435da97bf.png";